import { Box, Stack, Typography, Link } from '@mui/material'
import { Toolbar } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { Link as RouterLink } from 'react-router-dom'
import { TypeRoute } from 'core/TypeRoute'
import { KBottomAppBar } from './KBottomAppBar'
import { MainLogo } from 'components/images'
import { useTranslation } from 'react-i18next'

export const KFooter = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  const currentYear = new Date().getFullYear()

  return (
    <KBottomAppBar position="static">
      <Toolbar disableGutters>
        <MainLogo width={84} />
        <Box sx={{ flexGrow: 1 }}></Box>
        <Stack alignItems="flex-end">
          <Typography color="text.primary" variant="subtitle2">
            {t(`Version ${process.env.REACT_APP_VERSION ?? '0.1.0'}`)}
          </Typography>
          <Typography color="text.primary" variant="subtitle2">
            {t(`${currentYear} ChaChaPOS Inc.`)}
          </Typography>
          <Typography color="text.primary" variant="subtitle2">
            {t('All Rights Reserved.')}
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Link
              variant="subtitle2"
              color="text.primary"
              href="https://kiolyn.com"
              target="_blank"
              sx={{
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              kiolyn.com
            </Link>
            <Typography
              variant="subtitle2"
              component={RouterLink}
              to={TypeRoute.PrivacyPolicy}
              sx={{
                color: theme.palette.text.primary,
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              {t('Privacy Policy')}
            </Typography>
          </Box>
        </Stack>
      </Toolbar>
    </KBottomAppBar>
  )
}
